import navBarHomepage from '../modules/navbar-homepage';
import config from '../config';
//import { pollManager } from '../modules/collection_poll';


export default () => {
    navBarHomepage.on();
    if (config.get('featureFlags.pollsEnabled') === true) {
        // pollManager().init();
    }
};
